export const TermsConditions = {
    Title: 'Terms and Conditions',
    Buttons: {
        Agree: {
            label: 'Agree'
        },
        Decline: {
            label: 'Decline'
        }
    }
}



// WEBPACK FOOTER //
// ./src/localization/TermsConditions.ts